import { Component, OnInit, Input } from '@angular/core';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../auth/authentication.service';
import { LoopBackAuth } from '../../shared/sdk/services/core/auth.service';
import { CustomerApi } from '../../shared/sdk/services/custom/';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';

import { ContextService } from '../../auth/context.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
  public DEFAULT_LANGUAGE = "es";
  public formGroup: FormGroup;

  returnUrl: string;
  constructor(
    private loopBackAuth: LoopBackAuth,
    private customerApi: CustomerApi,
    private route: ActivatedRoute,
    private router: Router,    // private router: Routes,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder
  ) {
    this.buildForm();

    // redirect to home if already logged in
    if (this.customerApi.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.buildForm();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  private buildForm() {
    this.formGroup = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  onKeydown(event: any) {
    this.logIn(event);
  }

  logIn($eventevent: Event) {
    this.spinner.show();
    this.customerApi.login({username: this.formGroup.get('username').value,
                            password: this.formGroup.get('password').value }).subscribe(data => {
        // navigate to main view
        this.router.navigate([this.returnUrl]);
        this.spinner.hide();
      },
      err => {
        this.spinner.hide();

        if (err && err.statusCode && err.statusCode === 401) {
          console.log('unauthorized');

          this.toastr.info('No autorizado, Username o password no correcto', 'Login incorrecto', {
            timeOut: 4000
          });
        } else {
          console.log(err);

          this.toastr.error(err, 'Error', {
            timeOut: 4000
          });
        }
      });

     event.preventDefault(); // Avoid default action for the submit button of the login form
  }

  public getError(controlName: string): string {
    let error = '';
    const control = this.formGroup.get(controlName);
    if (control.touched && control.errors != null) {
      error = JSON.stringify(control.errors);
      if (control.errors.required) {
        // TODO tranducir
        error = 'Requerido';
      }
    }
    return error;
  }
}
